import React from 'react'
import { Col, Container, Row, Spinner } from 'react-bootstrap'
import CardProductContainer from '../../components/Products/CardProductContainer'
import Pagination from '../../components/Layout/Pagination'
import UseProductOnCategory from '../../CustomHooks/Products/UseProductOnCategory'
import NavBar from '../../components/Layout/NavBar'
import Footer from '../../components/Layout/Footer'
import UseViewSearchProducts from '../../CustomHooks/Products/UseViewSearchProducts'

const ProductByCategory = () => {
    const [categoryProducts, pagescount, onPress, loading, CategoryName] = UseProductOnCategory();
    const [NumberOfPages, AllLoading, SearchLoading, items, onPressPage, searchProductsFunc, onChangeSearchInput, searchInputValue] = UseViewSearchProducts()
    return (
        <>
            <NavBar onChangeSearchInput={onChangeSearchInput} searchInputValue={searchInputValue} />
            <div className='mh-100-exact'>
                <div className='gray-bg py-3'>
                    <Container>
                        <h3 className='mb-0'>{CategoryName} Products</h3>
                    </Container>
                </div>
                <Container>
                    <Row className="d-flex flex-row">
                        {loading === false ? categoryProducts && categoryProducts.length >= 1 ? (
                            <Col>
                                <CardProductContainer products={categoryProducts} />
                                {pagescount > 1 ? (<Pagination pageCount={pagescount} onPress={onPress} />) : null}
                            </Col>)
                            : (
                                <Col className='mh-100vh mt-5'>
                                    <div className='alert alert-warning'> No Products You Can browse another category</div>
                                </Col>
                            ) : (<div className='d-flex justify-content-center align-items-center mt-5 pt-5'>
                                <Spinner animation="border" variant="danger" />
                            </div>)}
                    </Row>
                </Container>
            </div >
            <Footer />
        </>
    )
}

export default ProductByCategory
